cockpitApp.directive('bannerBrand', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: '/element/detail/banner-brand',
        controllerAs: 'bannerBrandCtrl',
        controller: 'bannerBrandController'
    };
});
